var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9987 0.833008C14.7862 0.833008 0.832031 14.7872 0.832031 31.9997C0.832031 49.2122 14.7862 63.1664 31.9987 63.1664C49.2112 63.1664 63.1654 49.2122 63.1654 31.9997C63.1654 14.7872 49.2112 0.833008 31.9987 0.833008ZM45.508 26.7297C45.7568 26.4453 45.9462 26.1141 46.065 25.7555C46.1839 25.3969 46.2298 25.0181 46.2001 24.6415C46.1705 24.2648 46.0657 23.8979 45.8922 23.5624C45.7186 23.2268 45.4797 22.9293 45.1894 22.6875C44.8992 22.4456 44.5635 22.2642 44.2021 22.154C43.8408 22.0438 43.461 22.007 43.0852 22.0457C42.7094 22.0844 42.3451 22.1979 42.0138 22.3795C41.6825 22.5611 41.3909 22.8071 41.156 23.103L28.9727 37.7202L22.6685 31.4132C22.1342 30.8971 21.4185 30.6115 20.6756 30.6179C19.9327 30.6244 19.222 30.9224 18.6967 31.4477C18.1714 31.973 17.8734 32.6837 17.867 33.4265C17.8605 34.1694 18.1461 34.8851 18.6622 35.4195L27.1622 43.9195C27.4406 44.1977 27.7739 44.4149 28.1409 44.5572C28.5079 44.6995 28.9004 44.7637 29.2936 44.7459C29.6868 44.728 30.072 44.6284 30.4245 44.4535C30.7771 44.2785 31.0893 44.032 31.3414 43.7297L45.508 26.7297Z",
    fill: "#583D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.04a38d4e7b079de6c3ca6b03ffea63e9.svg";
export { ForwardRef as ReactComponent };